import styled from 'styled-components';

const Container = styled.ul`
    padding-left:${({ theme }) => theme.Spacing.spacing0x};
    border-width: 1px 1px 0 1px;
    border-style: solid;
    border-color:${({ theme }) => theme.Colors.Aliases.divider};
    margin-bottom: ${({ theme }) =>  theme.Spacing.spacing1x};
`;

export default Container;
